import { Container, Title, ContatoContainer, ContatoItem, PrincipalContatoItem } from "./styles";
import { FaLocationArrow, FaPhoneAlt, FaVoicemail } from "react-icons/fa";
import { Image } from "react-bootstrap";

export default function Contato() {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                position: "relative",
            }}
        >
            <Container>
                <div
                    id="contato"
                    style={{
                        position: "absolute",
                        top: "-110px",
                        left: "50px",
                    }}
                    className="d-flex align-items-center"
                >
                </div>
                <Title>
                    <p style={{ textShadow: "1px 1px 2px black" }}>Contate-nos</p>
                    <p
                        style={{
                            fontSize: 25,
                            letterSpacing: 2,
                            textShadow: "1px 1px 2px black",
                        }}
                    >
                        ESTAMOS À DISPOSIÇÃO
                    </p>
                    <hr></hr>
                </Title>
                <br></br>
                <br></br>
                <ContatoContainer>
                    <PrincipalContatoItem>
                        <FaLocationArrow style={{ marginRight: 20 }}></FaLocationArrow>
                        BR-060, 381 - St. Industrial, Rio Verde - GO, 75.905-025 - Matriz
                    </PrincipalContatoItem>
                    <PrincipalContatoItem>
                        <FaPhoneAlt style={{ marginRight: 20 }} />( 64 ) 3611 - 8400
                    </PrincipalContatoItem>
                    <PrincipalContatoItem>
                        <FaVoicemail style={{ marginRight: 20 }} />
                        sac@grupocereal.com.br
                    </PrincipalContatoItem>
                </ContatoContainer>
            </Container>
        </div>
    );
}
